<div class="row col-12 p-0 m-0 main-page-section ">
  <div class="col-12 p-0 employee-section">
    <div class="col-height">
      <div class="company">
        <div class="breadcrumbs-section pl-2 ml-5">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/company">Companies</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Company Details</span>
        </div>

        <div class="company-layout">

          <div class="row d-flex align-items-center">
            <div class="col-4">
              <h1>Company Details</h1>
            </div>
            <div class="col-2 result" style="color: #01539a;" [routerLink]="['/company/edit-company', parkTenantId]"
              *ngIf="companyEdit">Edit Details</div>
            <div class="col-2 result" style="color: #01539a;"
              [routerLink]="['/company/create-meeting-room', parkTenantId]"
              *ngIf="companyEdit && totalMeetingRoomCount < maxConferenceRoom && isTenantExpired===false">Add Meeting
              Room
            </div>
            <div class="col-2 result" style="color: #01539a;"
              [routerLink]="['/company/view-meeting-room', parkTenantId]"
              *ngIf="companyEdit && isTenantExpired===false">
              View Meeting Room
            </div>
            <div class="col-4"></div>
          </div>

          <div class="row mt-4">
            <div class="col-4">
              <p class="title">Company Name</p>
              <!-- <p class="result">{{myCompanyData?.CompanyName}}</p> -->
              <p class="result">{{myCompanyData.companyName}}</p>

            </div>
            <div class="col-6">
              <p class="title"> Official Website</p>
              <p class="result">{{myCompanyData?.officialWebsite}}</p>
              <!--<p class="result">abc.gmail.com</p>-->

            </div>
            <div class="col-2"></div>
          </div>

          <div class="row mt-2">
            <div class="col-6">
              <p class="title">Building Name</p>
              <p class="result">{{myCompanyData?.buildingName}}</p>
              <!--<p class="result">Building</p>-->

            </div>
            <div class="col-6"></div>
          </div>
        </div>
      </div>

      <div class="tabs-layout mt-2">
        <tabs [tabs]='tabs' (tabSelected)="selectedItem($event)"></tabs>
      </div>


      <admin-coadmin *ngIf="showAdminCoadmin && isLoaded" [list]="employeeList" (refreshData)="getMyCompanyDetails()"></admin-coadmin>
      <ert *ngIf="showErt && isLoaded" [list]="employeeList" (refreshDataErt)="getMyCompanyDetails()"></ert>
      <app-active-employees *ngIf="showActiveEmp && isLoaded" [list]="employeeList"></app-active-employees>
      <app-inactive-employees *ngIf="showInactiveEmp && isLoaded" [list]="employeeList"></app-inactive-employees>

      <!-- <app-footer></app-footer> -->



    </div>
    <!-- <empty-state *ngIf="((employeeList !== null && employeeList?.length <= 0) || employeeList === null) && !showActiveEmp && !showInactiveEmp"></empty-state> -->